export const API_URL = process.env.NEXT_PUBLIC_API_URL;
export const WEBSOCKET_URL = process.env.NEXT_PUBLIC_WEBSOCKET_URL;
export const FRONTEND_URL = process.env.NEXT_PUBLIC_FRONTEND_URL;
export const ASPECT_REVIEW = '/doc/act/review';
export const ASPECT_QUESTION = '/doc/act/question';
